<template>
  <div>
    <avue-crud
      ref="crud"
      :data="data"
      :option="option"
      @on-load="onLoad"
      :search.sync="searchForm"
      @search-change="searchChange"
      @refresh-change="onLoad"
      :span-method="spanMethod"
    >
      <template #receivableTimeSearch="{ row }">
        <el-date-picker
          v-model="row.receivableTime"
          type="month"
          placeholder="选择月"
          value-format="yyyy-MM"
        />
      </template>
      <!-- <template #companynumber="{row}">
        <router-link :to="`/statistics/accountDataAnalysis-details?
          tab=4&
          operationDate=${search.receivableTime}&
          productCode=shebao`.replace(/\n| /g,'')" class="el-link el-link--primary is-underline">
          {{row.companynumber}}
        </router-link>
      </template> -->
      <template #xqyht="{ row }">
        <router-link
          :to="
            `/statistics/accountDataAnalysis-details?
          tab=4&
          cooperationStartTime=${search.receivableTime}&
          department=${row.department}`.replace(/\n| /g, '')
          "
          class="el-link el-link--primary is-underline"
          v-if="row.department != '合计' "
        >
          {{ row.xqyht }}
        </router-link>
        <el-tag type="warning" v-else>
          {{ row.xqyht }}
        </el-tag>
      </template>
      <template #departmentSearch="{ row }">
        <el-select
          v-model="row.department"
          multiple
          collapse-tags
          placeholder="请选择"
        >
          <el-option
            v-for="item in teamDeptDict"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </template>
      <!-- <template #yqyht="{row}">
        <router-link :to="`/statistics/accountDataAnalysis-details?
          tab=4&
          operationDate=${search.receivableTime}&
          productCode=shebao`.replace(/\n| /g,'')" class="el-link el-link--primary is-underline">
          {{row.yqyht}}
        </router-link>
      </template> -->
      <!-- <template #xzht="{row}">
        <router-link :to="`/statistics/accountDataAnalysis-details?
          tab=4&
          operationDate=${search.receivableTime}&
          productCode=shebao`.replace(/\n| /g,'')" class="el-link el-link--primary is-underline">
          {{row.xzht}}
        </router-link>
      </template>
      <template #zfht="{row}">
        <router-link :to="`/statistics/accountDataAnalysis-details?
          tab=4&
          operationDate=${search.receivableTime}&
          productCode=shebao`.replace(/\n| /g,'')" class="el-link el-link--primary is-underline">
          {{row.zfht}}
        </router-link>
      </template> -->
    </avue-crud>
  </div>
</template>

<script>
import { contractAward } from "@/api/cube-agent/charges_statistics";
import { mapGetters, mapMutations, mapState } from "vuex";
export default {
  data() {
    return {
      data: [],
      search: {},
      searchForm: {},
        spanArr:[],
        key: "parentId",
      option: {
        emptyText:"暂无数据",
        searchFilterNull: true,
        searchFilterDic: true,
        height: "auto",
        calcHeight: 30,
        searchSpan: 4,
        searchBtnText:'查询',
        searchMenuPosition:'left',
        searchMenuSpan : 6,
        addBtn: false,
        page: false,
        align: "center",
        menuAlign: "center",
        border: true,
        menu: false,
        rowKey: "$index",
        column: [
          {
            height: "auto",
            calcHeight: 30,
            searchSpan: 4,
            searchBtnText:'查询',
            searchMenuPosition:'left',
            searchMenuSpan : 4,
            label: "周期",
            prop: "receivableTime",
            hide: true,
            search: true,
            searchslot: true,
          },
            {
                label: "上级部门",
                prop: "parentId",
                dicUrl: "/api/cube-agent/charges_statistics/getdeptlist",
                props: {
                    label: "dictValue",
                    value: "dictKey",
                },
            },
          {
            label: "部门",
            prop: "department",
            searchFilterable: true,
            dicUrl: "/api/cube-agent/charges_statistics/getdeptlist?isShow=1",
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            type: "select",
            searchSpan: 5,
            searchslot: true,
            search: true,
          },
          {
            label: "客户数量",
            prop: "companynumber",
          },
          {
            label: "需签约客户",
            prop: "xqyht",
            slot: true,
          },
          {
            label: "已签约客户",
            prop: "yqyht",
          },
          // {
          //   label: '未签约合同',
          //   prop: 'wqyht',
          // },
          {
            label: "新增合同",
            prop: "xzht",
          },
          {
            label: "作废合同",
            prop: "zfht",
          },
          // {
          //   label: '契约锁待审核',
          //   prop: 'date',
          // },
          // {
          //   label: '契约锁待签订',
          //   prop: 'date',
          // },
          // {
          //   label: '契约锁已完成',
          //   prop: 'date',
          // },
          // {
          //   label: '实际签约合同',
          //   prop: 'sjqyht',
          // },
          // {
          //   label: '总金额',
          //   prop: 'date',
          // },
          // {
          //   label: '已收金额',
          //   prop: 'date',
          // },
          // {
          //   label: '未收金额',
          //   prop: 'date',
          // },
          // {
          //   label: '周期',
          //   prop: 'date1',
          //   search: true,
          //   searchslot: true,
          // },
        ],
      },
    };
  },
  computed: {
    ...mapState("dictSystem", ["teamDeptDict"]),
    ...mapGetters(["userInfo"]),
  },
  mounted() {
    this.TeamDeptDict();
    this.searchForm.receivableTime = this.searchForm.receivableTime || moment().format("YYYY-MM");
  },
  methods: {
      rowspan() {
          this.spanArr=[];
          this.position=0;
          this.data.forEach((item,index)=>{
              if(index===0){
                  this.spanArr.push(1)
                  this.position=0;
              }else{
                  if(this.data[index][this.key]===this.data[index-1][this.key]){
                      this.spanArr[this.position] +=1;
                      this.spanArr.push(0)
                  }else{
                      this.spanArr.push(1)
                      this.position=index
                  }
              }
          })
      },
      spanMethod({ row, column, rowIndex, columnIndex }) {
          if(column.property==[this.key]){
              const _row=this.spanArr[rowIndex];
              const _col=_row>0?1:0;
              return {
                  rowspan:_row,
                  colspan:_col
              }
          }
      },
    ...mapMutations("dictSystem", ["TeamDeptDict"]),
    async onLoad() {
      await this.$nextTick()
      await this.$nextTick()
      this.search = this.searchForm;
      const {
        data: {
          data: {
            page,
            sjqyht,
            wqyht,
            xqyht,
            xzht,
            yqxht,
            zfht,
            companynumber,
            yqyht,
          },
        },
      } = await contractAward({
        ...this.searchForm,
        tenantId: this.userInfo.tenant_id,
        department:this.searchForm.department?this.searchForm.department.join(','):undefined
        // current: this.page.currentPage,
        // size: this.page.pageSize,
      });
      this.data = [
        {
          department: "合计",
          companynumber,
          sjqyht,
          wqyht,
          xqyht,
          xzht,
          yqxht,
          zfht,
          yqyht,
        },
        ...page,
      ];
        this.rowspan()
    },
    async searchChange(f, d) {
      await this.onLoad();
      d();
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .avue-crud__pagination {
    display: none;
  }
  .avue-crud__menu {
    display: none;
  }
}
</style>
